import { MapInstance } from './map';
import mapStyles from './Utils/mapStyles';
import { createMap } from './Utils/utils';

export { createMap, mapStyles, MapInstance };

export default MapInstance;
